function clearBikeCartMobile () {
    let attys = {
      attributes: {}
    }

    attys.attributes['name'] = null;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(attys)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Handle the response as needed
      console.log('Cart updated:', data);
    })
    .catch(function(error) {
      console.error('Error updating cart:', error);
    });
  }

if (window.innerWidth <= 701) {
  if (document.querySelector('#bike-remove-mobile')) {
  document.querySelector('#bike-remove-mobile').onclick = () => {
        clearBikeCartMobile()

        setTimeout(()=> {
          
        sessionStorage.removeItem("bikeName")
        sessionStorage.removeItem("searchTerm")
        sessionStorage.removeItem("fitments")
        document.querySelector('#bike-remove-mobile').style.display = 'none'
        document.querySelector('#bike-name-mobile').style.display = 'none'
        document.querySelector('.btn-success').style.display = 'none'
        document.querySelector('.btn-danger').style.display = 'none'
    document.querySelector('#bike-remove-mobile').style.display = 'none'
        window.location.reload()
        if (window.location.href.includes("page=")) {
          window.location.href = window.location.href.split('&')[0]
        } else {
          window.location.href = window.location.href.split('?')[0]
        }
        
      },500)
      }

  }
}
  
  if (document.querySelector('#bike-remove')) {
  document.querySelector('#bike-remove').onclick = () => {

        sessionStorage.removeItem("bikeparams")
        sessionStorage.removeItem("bikeName")
        sessionStorage.removeItem("searchTerm")
        sessionStorage.removeItem("fitmentlist")
        document.querySelector('#bike-remove').style.display = 'none'
        document.querySelector('#bike-name').style.display = 'none'
        document.querySelector('.btn-success').style.display = 'none'
        document.querySelector('.btn-danger').style.display = 'none'
    document.querySelector('#bike-remove').style.display = 'none'
        cleared = true
        window.location.reload()
        if (window.location.href.includes("page=")) {
          window.location.href = window.location.href.split('&')[0]
        } else {
          window.location.href = window.location.href.split('?')[0]
        }
        
      }
      }
  if (!sessionStorage.getItem('bikeName') && document.querySelector('#bike-remove')) {
          document.querySelector('#bike-remove').style.display = 'none'    
    }
